import React from 'react';
import { motion } from 'framer-motion';
import { Beef, Crosshair, BatteryLow } from 'lucide-react';
const symptoms = [{
  icon: Beef,
  title: 'La barriga de "estrés"',
  description: 'Esa grasa abdominal inflamatoria que aparece aunque "comas sano".'
}, {
  icon: Crosshair,
  title: 'La pérdida del "Borde"',
  description: 'Esa fracción de segundo que pierdes al tomar decisiones bajo presión.'
}, {
  icon: BatteryLow,
  title: 'La fatiga invisible',
  description: 'Estar exhausto a las 4 PM pero con la mente acelerada a las 11 PM sin poder descansar.'
}];
export function Agitation() {
  return <section className="py-20 md:py-28 px-4" data-id="element-12">
      <div className="max-w-5xl mx-auto" data-id="element-13">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.5
      }} className="text-center mb-12 max-w-3xl mx-auto" data-id="element-14">
          <span className="inline-block text-brand-orange font-bold tracking-widest text-xs md:text-sm uppercase mb-4" data-id="element-15">
            — El Costo del Declive —
          </span>
          <h2 className="text-3xl md:text-5xl font-bold text-white uppercase mb-6" data-id="element-16">
            Un entorno diseñado para tu{' '}
            <span className="text-brand-orange" data-id="element-17">autodestrucción biológica</span>
          </h2>
          <p className="text-lg text-brand-muted leading-relaxed" data-id="element-18">
            El estrés crónico de los negocios dispara el cortisol, y el cortisol
            es el interruptor maestro que apaga tu hombría.
          </p>
        </motion.div>

        <div className="text-center mb-10" data-id="element-19">
          <p className="text-xl md:text-2xl font-display font-bold text-white uppercase tracking-wide" data-id="element-20">
            ¿Te suena familiar?
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-6 mb-12" data-id="element-21">
          {symptoms.map((s, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: i * 0.1
        }} className="bg-brand-darker border border-brand-gray rounded-lg p-6 hover:border-brand-orange/60 transition-colors" data-id="element-22">
              <div className="bg-brand-orange/10 w-12 h-12 rounded-md flex items-center justify-center mb-4" data-id="element-23">
                <s.icon className="w-6 h-6 text-brand-orange" data-id="element-24" />
              </div>
              <h3 className="text-xl font-bold text-white uppercase mb-2 tracking-wide" data-id="element-25">
                {s.title}
              </h3>
              <p className="text-brand-muted" data-id="element-26">{s.description}</p>
            </motion.div>)}
        </div>

        <motion.div initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center max-w-3xl mx-auto" data-id="element-27">
          <p className="text-2xl md:text-3xl font-display font-bold text-white uppercase" data-id="element-28">
            Esto no es envejecer. <br data-id="element-29" />
            <span className="text-brand-orange" data-id="element-30">
              Esto es declive sistémico.
            </span>
          </p>
          <p className="text-brand-muted text-lg mt-4" data-id="element-31">
            Y si no lo detienes hoy, el próximo año tu "máquina" estará aún más
            desgastada.
          </p>
        </motion.div>
      </div>
    </section>;
}